import React from 'react';
import { format } from 'date-fns';
import { Mail, MessageSquare, Phone } from 'lucide-react';
import { Lead } from '../data/mockLeads';
import { Badge } from './Badge';
import { Button } from './Button';
interface LeadRowProps {
  lead: Lead;
  onAction: (id: string, action: string) => void;
}
export function LeadRow({
  lead,
  onAction
}: LeadRowProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(amount);
  };
  const getCampaignBadge = () => {
    switch (lead.campaignType) {
      case 'email':
        return <Badge variant="info" className="flex items-center gap-1" data-id="element-106">
            <Mail size={12} data-id="element-107" /> Email Drip
          </Badge>;
      case 'sms':
        return <Badge variant="purple" className="flex items-center gap-1" data-id="element-108">
            <MessageSquare size={12} data-id="element-109" /> SMS Drip
          </Badge>;
      case 'mixed':
        return <Badge variant="default" className="flex items-center gap-1" data-id="element-110">
            <Phone size={12} data-id="element-111" /> Multi-channel
          </Badge>;
    }
  };
  const getStatusBadge = () => {
    switch (lead.status) {
      case 'pending':
        return <Badge variant="warning" data-id="element-112">Pending</Badge>;
      case 'contacted':
        return <Badge variant="success" data-id="element-113">Contacted</Badge>;
      case 'snoozed':
        return <Badge variant="default" data-id="element-114">Snoozed</Badge>;
    }
  };
  return <tr className="border-b border-slate-100 hover:bg-slate-50 transition-colors group" data-id="element-115">
      <td className="py-4 px-6" data-id="element-116">
        <div className="flex flex-col" data-id="element-117">
          <span className="font-semibold text-slate-900" data-id="element-118">{lead.name}</span>
          <span className="text-sm text-slate-500" data-id="element-119">{lead.email}</span>
          <span className="text-sm text-slate-500" data-id="element-120">{lead.phone}</span>
        </div>
      </td>
      <td className="py-4 px-6" data-id="element-121">
        <div className="flex flex-col" data-id="element-122">
          <span className="font-medium text-slate-900" data-id="element-123">
            {formatCurrency(lead.loanAmount)}
          </span>
          <span className="text-sm text-slate-500" data-id="element-124">{lead.loanPurpose}</span>
        </div>
      </td>
      <td className="py-4 px-6" data-id="element-125">
        <div className="flex flex-col gap-1" data-id="element-126">
          <span className="text-sm text-slate-900 font-medium truncate max-w-[180px]" title={lead.campaignName} data-id="element-127">
            {lead.campaignName}
          </span>
          <div data-id="element-128">{getCampaignBadge()}</div>
        </div>
      </td>
      <td className="py-4 px-6" data-id="element-129">
        <div className="flex flex-col" data-id="element-130">
          <span className="text-sm text-slate-900" data-id="element-131">
            {format(new Date(lead.lastContact), 'MMM d, yyyy')}
          </span>
          <span className="text-xs text-slate-500" data-id="element-132">
            {format(new Date(lead.lastContact), 'h:mm a')}
          </span>
        </div>
      </td>
      <td className="py-4 px-6" data-id="element-133">{getStatusBadge()}</td>
      <td className="py-4 px-6 text-right" data-id="element-134">
        <div className="flex items-center justify-end gap-2" data-id="element-135">
          <Button variant="ghost" size="sm" className="h-8 w-8 p-0 rounded-full" onClick={() => onAction(lead.id, 'call')} title="Log Call" data-id="element-136">
            <Phone size={16} data-id="element-137" />
          </Button>
          <Button variant="ghost" size="sm" className="h-8 w-8 p-0 rounded-full" onClick={() => onAction(lead.id, 'email')} title="Send Email" data-id="element-138">
            <Mail size={16} data-id="element-139" />
          </Button>
        </div>
      </td>
    </tr>;
}